// extracted by mini-css-extract-plugin
export var equalColumn = "_ig-0";